import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { getActivityInformations } from '@/api/common';
import { getUserRankDailyCheckin } from '@/api/level';
import LevelViewOne from '@/themes/themeOne/level/levelView.vue';
import LevelViewTwo from '@/themes/themeTwo/level/levelView.vue';
import LevelViewThree from '@/themes/themeThree/level/levelView.vue';
import LevelViewFour from '@/themes/themeFour/level/levelView.vue';
import { onMounted, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { LevelViewData, RankConfig, RankItem, RewardItem } from './supportScript';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'levelView',
  setup(__props) {

const { t } = useI18n();

const levelRef = ref()
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const isLoading = ref(false)
const activityInfo = ref([])
const rewardsList = ref<RewardItem[]>([])
const levelList = ref<RankItem[]>([])
const rankConfig = ref<RankConfig>({
    ranksConfigData: {
        rank_list: [],
    },
    rank: 0,
    rewardData: {
        rewards: []
    },
    amount: 0
})
const activeRank = ref(0)
const currentRankName = ref('')
const currentRankIcon = ref('')

const dataSet = computed<LevelViewData>(() => ({
    activityInfo: activityInfo.value,
    isLoading: isLoading.value,
    rewardsList: rewardsList.value,
    levelList: levelList.value,
    rankConfig: rankConfig.value,
    activeRank: activeRank.value,
    currentRankName: currentRankName.value,
    currentRankIcon: currentRankIcon.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getLevelInformations = () => {
    let data = {
        activityId: "USER_RANK"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        levelRef.value.isLoadingFalse()
        let resdata = res.data
        rankConfig.value = resdata.config
        levelList.value = rankConfig.value.ranksConfigData.rank_list
        activeRank.value = rankConfig.value.rank
        activityInfo.value = JSON.parse(resdata.activityIntro);
        rewardsList.value = rankConfig.value.rewardData.rewards
        currentRankName.value = levelList.value.find(item => item.rank == activeRank.value)?.rank_name || ''
        currentRankIcon.value = levelList.value.find(item => item.rank == activeRank.value)?.icon2 || ''
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const userRankDailyCheckin = () => {
    levelRef.value.isLoadingTrue()
    getUserRankDailyCheckin().then(res => {
        let resdata = res.data
        showSuccess(res.msg)
        setTimeout(() => {
            getLevelInformations()
        }, 300)
    }).catch(err => {
        showError(err);
        levelRef.value.isLoadingFalse()
    })
}

onMounted(() => {
    loadingRef.value.open()
    getLevelInformations()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LevelViewOne, {
            ref_key: "levelRef",
            ref: levelRef,
            "data-set": dataSet.value,
            onUserRankDailyCheckin: userRankDailyCheckin
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LevelViewTwo, {
            ref_key: "levelRef",
            ref: levelRef,
            "data-set": dataSet.value,
            onUserRankDailyCheckin: userRankDailyCheckin
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(LevelViewThree, {
            ref_key: "levelRef",
            ref: levelRef,
            "data-set": dataSet.value,
            onUserRankDailyCheckin: userRankDailyCheckin
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(LevelViewFour, {
            ref_key: "levelRef",
            ref: levelRef,
            "data-set": dataSet.value,
            onUserRankDailyCheckin: userRankDailyCheckin
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})